var _ = require('lodash'),
  activeEvent = require('../events/eventObserver').active,
  log = require('../libraries/logger').getLoggerInstance('Base.QueueUtility'),
  passiveEvent = require('../events/eventObserver').passive,
  RSVP = require("rsvp");

var privateMethods = {
  ProcessQueue: function (queue, eventObserver) {
    var promise = new RSVP.Promise(function (resolve, reject) {
      try {
        if (queue.length) {
          log.debug('Found [' + queue.length + '] element(s) in queue.');
          _.each(queue, function (evt) {
            log.debug('Processing [' + evt.name + ']...');
            if (eventObserver._type === 'active') {
              eventObserver.publish.apply(this, _.union([evt.name], evt.arguments));
            } else if (eventObserver._type === 'passive') {
              eventObserver.subscribe(evt.arguments[0], evt.arguments[1]);
            } else {
              log.error('Unable to publish or subscribe event.');
            }
          });
        } else {
          log.debug("[" + eventObserver._type + "] queue was empty");
        }

        resolve();
      } catch (error) {
        reject(error);
      }
    });

    return promise;
  }
},
  publicMethods = {
    ProcessActiveQueue: _.partial(privateMethods.ProcessQueue, _, activeEvent),
    ProcessPassiveQueue: _.partial(privateMethods.ProcessQueue, _, passiveEvent)
  };

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./utilities/queueUtility.js
// module id = 156
// module chunks = 5